export default "__VITE_ASSET__ea30309d__"